export const selectCampaigns = (state) => state.campaigns.campaignData;
export const selectCampaignsLoading = (state) =>  state.campaigns.loading;

export const selectCampaignTypes = (state) => state.campaigns.campaignTypes;
export const selectCampaignTypesLoading = (state) =>  state.campaigns.loadingTypes;

export const selectCampaignStatistics = (state)=> state.campaigns.campaignStatistics;
export const selectCampaignStatisticsLoading = (state) =>  state.campaigns.loadingStatistics;

export const selectCampaignStatisticsFilters = (state)=> state.campaigns.statisticFilters

export const selectCampaignMaster = (state)=> state.campaigns.campaignMaster;
export const selectCampaignMasterLoading = (state)=> state.campaigns.loadingMaster;
